import type { Country as CountryType } from '@/models/country';
import type { Fixture } from '@/models/fixture';
import type { gameResult } from '@/models/gameUpdate';
import { formatFixtureDisplayLabel } from '@/helpers';
import { MatchResultRow } from '../MatchResultRow';
import { FixtureMatchRow } from '../FixtureMatchRow';

export function TeamDetailFixtureRow(props: {
  fixture: Fixture;
  focusCountry?: CountryType;
  gameResult?: gameResult;
}) {
  const rawTitle = props.fixture.bracketLabel ?? props.fixture.matchId;
  const bracketLabel = rawTitle ? formatFixtureDisplayLabel(rawTitle) : undefined;
  const showBracketLabel = Boolean(bracketLabel);

  if (props.gameResult) {
    return (
      <MatchResultRow
        result={props.gameResult}
        svg
        expandable
        bracketLabel={bracketLabel}
        showBracketLabel={showBracketLabel}
      />
    );
  }

  return (
    <FixtureMatchRow
      fixture={props.fixture}
      showBracketLabel={showBracketLabel}
      bracketLabel={bracketLabel}
    />
  );
}
